import {AbstractModel} from './abstract-model';
import {Goal} from './goal';
import {OfferGoalType} from './offer-goal-type';

export class OfferGoal extends AbstractModel {
  id: number | null = null;
  goal: Goal | null = null;
  private: boolean | null = null;
  payoutAmount: number | null = null;
  payoutPercent: number | null = null;
  types: OfferGoalType[] = [];

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.goal) {
      this.goal = new Goal().deserialize(input.goal);
    }

    if (input.types) {
      this.types = input.types.map((type: any) => new OfferGoalType().deserialize(type));
    }

    return this;
  }
}
